import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
  Box, IconButton, Tooltip, TextField, InputAdornment
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

const InventoryTable = ({
  inventory,
  handleEditClick,
  handleDeleteClick,
  handleSearch,
}) => {
  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 3, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Inventory Items</Typography>
        <TextField
          size="small"
          placeholder="Search items..."
          onChange={(e) => handleSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ bgcolor: 'primary.light' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Part ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Category</TableCell>
              {/* New Table Headers for prices */}
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Buying Price (LKR)</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Sales Price (LKR)</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Quantity</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Low Stock Threshold</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inventory.map((item) => (
              <TableRow key={item._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>{item.partId}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.category}</TableCell>
                {/* New Table Cells for prices */}
                <TableCell align="right">{item.buyingPrice ? item.buyingPrice.toFixed(2) : '0.00'}</TableCell>
                <TableCell align="right">{item.salesPrice ? item.salesPrice.toFixed(2) : '0.00'}</TableCell>
                <TableCell align="right">{item.quantity}</TableCell>
                <TableCell align="right">{item.lowStockThreshold}</TableCell>
                <TableCell align="center">
                  <Tooltip title="Edit">
                    <IconButton onClick={() => handleEditClick(item)}>
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => handleDeleteClick(item._id)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default InventoryTable;